import { getMessagingInstance  } from "./FirebaseConfig";
import { getToken, onMessage, isSupported } from "firebase/messaging";
import Swal from 'sweetalert2';

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      return requestToken();
    } else {
      console.warn("Notification permission denied");
    }
  } catch (error) {
    console.error("Error getting notification permission:", error);
  }
};

export const requestToken = async () => {

  try {
     const messaging = await getMessagingInstance();
    if (messaging) {
        const token = await getToken(messaging, {
          vapidKey:  process.env.REACT_APP_VAPID_KEY, 
        });
        return token;
      }
  } catch (error) {
    console.error("Error getting notification permission:", error);
  }
}

getMessagingInstance().then((messaging) => {
  if (messaging) {
    onMessage(messaging, (payload) => {
      if(payload.notification.title) {
      if( payload.notification.title === 'TradeUpdate'){
        var trade = JSON.parse(payload.notification.body);
          if(trade) {
                  Swal.fire({
                    title: `<small>${trade.orderType.split("-")[0] + " Order "+ trade.status}</small>`,
                    width: 480,
                    icon: "success",
                    color: "#fff",
                    background: "#000",
                    html: `
                      <Table style="width:100%;"><thead></thead><tbody>
                        <tr><td style="color:#fff !important; white-space: nowrap; text-align:left; padding-left: 15%; ">${trade.segment + " " + trade.symbol}</td> <td style="color:#fff !important; text-align:left">${trade.expiry}</td></tr>
                        <tr><td style="color:#fff !important; white-space: nowrap; text-align:left; padding-left: 15%;">Lot:</td> <td style="color:#fff !important; text-align:left">${trade.lot}</td></tr>
                        <tr><td style="color:#fff !important; white-space: nowrap; text-align:left; padding-left: 15%;">Quantity:</td> <td style="color:#fff !important; text-align:left">${trade.quantity}</td></tr>
                        <tr><td style="color:#fff !important; white-space: nowrap; text-align:left; padding-left: 15%;">OrderType:</td> <td style="color:#fff !important; text-align:left">${trade.orderType.includes("MP") ? "Market" : "Limit"}</td></tr>
                        <tr><td style="color:#fff !important; text-align:left; padding-left: 15%;">Price:</td> <td style="color:#fff !important; text-align:left">${trade.netRate}</td></tr>
                        </tbody>
                      </Table>
                    `,
                    showCloseButton: true,
                    showConfirmButton: true,
                    timer: 5000
                  });
            }
        } else if(payload.notification.title === 'UserStatusUpdate'){
          var user = JSON.parse(payload.notification.body);
          if(user) {
                  Swal.fire({
                    title: `<small>${user.userName}</small>`,
                    width: 480,
                    icon: "warning",
                    color: "#fff",
                    background: "#000",
                    html: `
                      <Table style="width:100%;"><thead></thead><tbody>
                        <tr><td style="color:#fff !important; text-align:left; padding-left: 22%;">${user.message}</td></tr>
                        </tbody>
                      </Table>
                    `,
                    showCloseButton: true,
                    focusConfirm: true,
                    confirmButtonText: `OK`
                  }).then((result) => {
                      window.location.pathname = "/login";
                  });
            }
        }
      }
      
    });
  }
 });


